import * as React from 'react'

export const RoundedImportIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7 2.5V9.5M4.5 7L7 9.5L9.5 7M1.5 11.5V14C1.5 14.8284 2.17157 15.5 3 15.5H11C11.8284 15.5 12.5 14.8284 12.5 14V11.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
